import React from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {AiOutlineArrowLeft} from "react-icons/ai";
import {useTranslation} from "react-i18next";

const ErrorPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {t} = useTranslation();

    const errorFunc = (status) => {
        switch (status) {
            case 400:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">400</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">Bad Request</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 401:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase ">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">401</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono text-red-500">Неавторизованный</p><br/>
                        <p className="text-7xl font-bold font-mono">Информации об этом e-mail в системе нет.Проверьте свою e-mail!</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 402:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">402</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">Payment Required</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 403:
                return (
                    <div cclassName="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase ">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">403</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">Forbidden</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 404:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase underline-offset-3 ">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">404</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono ">Not Found</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 405:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">405</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">Method Not Allowed</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 406:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">406</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">Not Acceptable</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 500:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">500</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">
                            Internal Server Error
                        </p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 501:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">501</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">Not Implemented</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 502:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">502</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">Bad Gateway</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 503:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">503</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">Service Unavailable</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 504:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3"> 504  </span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">Gateway Timeout</p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 505:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">505</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">
                            HTTP Version Not Supported
                        </p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );
            case 412:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">412 </span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">
                            {t('error.error')} ввода кода! Введите код еще раз!
                        </p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );

            case 413:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">413</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">
                            Проверьте адрес электронной почты или номер телефона!
                        </p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );

            case 414:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">414</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">
                            Не должен быть пустым e-mail или телефон!
                        </p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );

            case 415:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">415</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">
                            Не должен быть пустым Новый Пароль!
                        </p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );

            case 204:
                return (
                    <div className="w-[100vw] h-[100vh] bg-slate-100 flex flex-col justify-center items-center">
                        <h2 className="text-5xl mb-5 uppercase">
                            {t('error.status_code')} :
                            <span className="text-red-900 text-6xl font-mono font-bold ml-3">204</span>
                        </h2>
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        <p className="text-7xl font-bold font-mono">
                            ID не должен быть пустым!
                        </p>
                        <button
                            type="button"
                            className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => navigate(-1)}
                        >
                            <AiOutlineArrowLeft
                                className="-ml-1 mr-3 h-5 w-5"
                                aria-hidden="true"
                            />
                            {t('backward')}
                        </button>
                    </div>
                );

            default:
                return (
                    <div className="w-[100vw] h-[100vh] flex flex-col justify-center items-center">
                        {location.state.status && (
                            <h2 className="text-5xl mb-5 uppercase">
                                {t('error.status_code')} :
                                <span
                                    className="text-red-900 text-6xl font-mono font-bold ml-3">{location.state.status}</span>
                            </h2>
                        )}
                        <p className="text-7xl font-bold font-mono text-red-500">{t('error.error')}</p><br/>
                        {location.state.message && (
                            <p className="text-7xl font-bold font-mono">
                                {location.state.message}
                            </p>
                        )}
                        {(location.state.message || location.state.status) && (
                            <button
                                type="button"
                                className="inline-flex mt-5 items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                onClick={() => navigate(-1)}
                            >
                                <AiOutlineArrowLeft
                                    className="-ml-1 mr-3 h-5 w-5"
                                    aria-hidden="true"
                                />
                                {t('backward')}
                            </button>
                        )}
                    </div>
                );
        }
    };
    return <>{errorFunc(location.state.status)}</>;
};
export default ErrorPage;
